{
  "status": {
    "pending_payment": "Awaiting payment",
    "paid": "Paid — ready to ship",
    "ready_to_ship": "Ready to ship",
    "exported_to_click_drop": "Exported to Click & Drop",
    "shipped": "Shipped",
    "delivered": "Delivered",
    "released": "Payout released",
    "refunded": "Refunded",
    "cancelled": "Cancelled",
    "disputed": "Disputed"
  },
  "disputeStatus": {
    "open": "Open",
    "awaiting_seller": "Awaiting seller",
    "awaiting_buyer": "Awaiting buyer",
    "under_review": "Under review",
    "resolved_buyer": "Resolved (buyer)",
    "resolved_seller": "Resolved (seller)",
    "closed": "Closed"
  },
  "disputeReason": {
    "item_not_received": "Item not received",
    "item_not_as_described": "Item not as described",
    "damaged_item": "Damaged item",
    "wrong_item": "Wrong item sent",
    "suspected_counterfeit": "Suspected counterfeit",
    "missing_contents": "Missing contents",
    "tracking_problem": "Tracking problem",
    "other": "Other"
  },
  "disputeResolution": {
    "full_refund": "Full refund",
    "partial_refund": "Partial refund",
    "replacement": "Replacement",
    "other": "Other"
  },
  "page": {
    "eyebrow": "Orders",
    "title": "Your orders",
    "subtitle": "Track payments, shipments and payouts. All amounts in GBP."
  },
  "tabs": {
    "purchases": "My purchases",
    "sales": "My sales",
    "all": "All orders (admin)"
  },
  "loadError": "Couldn't load orders: {message}",
  "filtered": "Filtered:",
  "clearFilter": "Clear filter",
  "purchaseType": {
    "buyNow": "Buy It Now",
    "auction": "Auction"
  },
  "clickDrop": {
    "banner": "Royal Mail Click & Drop — select paid orders, export the CSV, then upload it in Click & Drop to buy postage.",
    "howToImport": "How to import",
    "exportSelected": "Export {count} selected to CSV"
  },
  "table": {
    "item": "Item",
    "status": "Status",
    "type": "Type",
    "payout": "Payout",
    "total": "Total",
    "actions": "Actions",
    "loading": "Loading…",
    "emptyFiltered": "No orders match the selected status filter.",
    "emptyBuyer": "You haven't won any auctions yet.",
    "emptySeller": "You haven't sold any items yet.",
    "emptyAdmin": "No orders on the platform yet.",
    "tracking": "Tracking: {number}",
    "labelError": "Label error: {message}",
    "disputeActive": "Dispute active",
    "payNow": "Pay now",
    "receiptSeller": "Sales invoice (PDF)",
    "receiptBuyer": "Receipt (PDF)",
    "clickDropCsv": "Click & Drop CSV",
    "retryLabel": "Retry Royal Mail label",
    "buyLabel": "Buy Royal Mail label",
    "downloadLabel": "Download & print label",
    "trackParcel": "Track parcel",
    "enterTracking": "Enter tracking & ship",
    "confirmDelivery": "Confirm delivery",
    "reportProblem": "Report a problem",
    "viewDispute": "View dispute",
    "releasePayout": "Release payout",
    "paidOut": "Paid out"
  },
  "toast": {
    "checkoutError": "Could not start checkout",
    "shippedSuccess": "Marked as shipped — buyer notified",
    "invoiceError": "Could not open invoice",
    "deliveryReleased": "Delivery confirmed — payment released to seller",
    "deliveryProcessing": "Delivery confirmed — payment processing",
    "deliveryConfirmed": "Delivery confirmed",
    "deliveryError": "Could not confirm delivery. Please try again.",
    "stripeTransferCreated": "Stripe transfer created: {id}",
    "exportedMarked": "Marked as exported — enter tracking once labels are printed",
    "labelDuplicate": "Label already exists for this order",
    "labelGenerated": "Royal Mail label generated — buyer emailed tracking",
    "labelFailed": "Label failed: {message}",
    "labelOpenError": "Could not open label: {message}",
    "missingAddressWarning": "{count} order(s) have no shipping address on file — CSV rows will be blank for those.",
    "movedUnderReview": "Moved to under review",
    "evidenceRequested": "Evidence requested",
    "disputeClosed": "Dispute closed",
    "resolvedSeller": "Resolved in seller's favour — payout released",
    "resolvedBuyer": "Refund issued",
    "evidenceUploaded": "Evidence uploaded",
    "invalidRefundAmount": "Invalid refund amount",
    "disputeResolved": "Dispute resolved",
    "disputeOpened": "Dispute opened — an admin will review"
  },
  "dialogs": {
    "shipment": {
      "title": "Enter tracking & mark shipped",
      "description": "Paste the tracking number from your Royal Mail Click & Drop label. The buyer is emailed automatically once you save.",
      "trackingLabel": "Tracking number",
      "trackingPlaceholder": "e.g. AB123456789GB",
      "trackingHelp": "Required. Enter the tracking / reference number Royal Mail printed on the label.",
      "cancel": "Cancel",
      "save": "Save tracking & notify buyer"
    },
    "guide": {
      "title": "Royal Mail Click & Drop — how to import your CSV",
      "description": "BidNova Auctions exports orders in the standard Click & Drop template so you can buy postage in a couple of minutes.",
      "step1": "Sign in at business.parcel.royalmail.com and open Orders → Import orders.",
      "step2": "Choose CSV as the format and upload the file you just downloaded from BidNova Auctions.",
      "step3": "On the field-mapping screen, pick BidNova Auctions from your saved mappings (Click & Drop remembers it after the first upload — our headers match their standard template).",
      "step4": "Review the imported orders, tick the ones you want to ship, and click Apply postage. The service column already shows the shipping method the buyer paid for.",
      "step5": "Print the labels, drop off at any Post Office or arrange collection, then come back here and click Enter tracking & ship — the buyer is emailed automatically.",
      "tip": "Tip: bulk-select multiple paid orders and export a single CSV — Click & Drop will create every order in one import.",
      "gotIt": "Got it"
    },
    "label": {
      "title": "Create Royal Mail label",
      "description": "Edit the parcel details for this order. Defaults come from your shipping settings.",
      "lastAttemptFailed": "Last attempt failed",
      "weight": "Weight (grams)",
      "packageType": "Package type",
      "packageTypes": {
        "letter": "Letter",
        "largeLetter": "Large Letter",
        "smallParcel": "Small Parcel",
        "mediumParcel": "Medium Parcel",
        "parcel": "Parcel"
      },
      "service": "Shipping service",
      "length": "Length (mm)",
      "width": "Width (mm)",
      "depth": "Depth (mm)",
      "dimensionsHint": "Dimensions are optional — leave at zero to use the package-type defaults.",
      "cancel": "Cancel",
      "retry": "Retry",
      "create": "Create label"
    },
    "release": {
      "title": "Release payout via Stripe Connect",
      "description": "Release {amount} to seller via Stripe Connect?",
      "cancel": "Cancel",
      "releasing": "Releasing…",
      "releaseButton": "Release via Stripe"
    },
    "pay": {
      "title": "Choose shipping",
      "description": "Pick a Royal Mail service. Shipping is added to your Stripe payment.",
      "method": "Shipping method",
      "item": "Item",
      "shipping": "Shipping",
      "total": "Total",
      "cancel": "Cancel",
      "redirecting": "Redirecting…",
      "continue": "Continue to Stripe"
    }
  },
  "orderDetail": {
    "status": "Order status",
    "shipment": "Shipment tracking",
    "trackingNumber": "Tracking number",
    "shippedAt": "Shipped at",
    "deliveryConfirmed": "Delivery confirmed by buyer",
    "yes": "Yes",
    "no": "No",
    "autoDeliverEligibility": "Auto-deliver eligibility",
    "payout": "Payout",
    "saleTotal": "Sale total",
    "commission": "Commission",
    "sellerPayout": "Seller payout",
    "released": "Released",
    "notYet": "Not yet",
    "stripeTransferId": "Stripe transfer ID",
    "disputes": "Disputes",
    "adminNote": "Admin note: {note}",
    "openDisputeCase": "Open dispute case",
    "resolveRefundTitle": "Refund the buyer",
    "resolveReleaseTitle": "Release funds to the seller",
    "resolveDismissTitle": "Dismiss this dispute",
    "resolveRefundDesc": "Marks the order as refunded and closes the dispute. The buyer will be notified.",
    "resolveReleaseDesc": "Closes the dispute. Payout can then be released once delivery conditions are met.",
    "resolveDismissDesc": "Closes the dispute without changing the order.",
    "resolveNotesLabel": "Resolution notes (shared with both parties)",
    "resolveNotesPlaceholder": "Explain the decision so both buyer and seller understand the outcome.",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "auditLog": "Audit log",
    "auditLogAdmin": "(admin view)",
    "noEvents": "No events yet.",
    "amount": "Amount: {amount}",
    "resumeCheckout": "Resume Stripe checkout",
    "viewAuction": "View auction"
  },
  "success": {
    "confirming": "Confirming your payment…",
    "confirmingHint": "Hang tight — this usually takes a second.",
    "pendingTitle": "Payment still processing",
    "pendingFallback": "Check back in a moment.",
    "pendingStatus": "Payment status: {status}",
    "goToOrders": "Go to my orders",
    "errorTitle": "Something went wrong",
    "orderReference": "Order reference:",
    "myOrders": "My orders",
    "contactSupport": "Contact support",
    "paidTitle": "Payment received",
    "paidSubtitle": "Thanks — the seller has been notified and will ship your card shortly.",
    "orderReferenceInline": "Order reference {ref}",
    "yourItem": "Your item",
    "auctionFallback": "Auction",
    "itemLabel": "Item",
    "shippingLabel": "Shipping",
    "totalPaid": "Total paid",
    "viewOrder": "View order",
    "continueBrowsing": "Continue browsing",
    "receiptEmailed": "A receipt and invoice have been emailed to you."
  },
  "orderCentre": {
    "eyebrow": "My Purchases",
    "title": "Order Centre",
    "subtitle": "Track every order across its lifecycle. Read-only view — use Contact Seller for questions.",
    "tabs": {
      "active": "Active",
      "waiting_dispatch": "Waiting for Dispatch",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "returned": "Returned"
    },
    "loading": "Loading…",
    "empty": "No orders in this category.",
    "table": {
      "orderNumber": "Order #",
      "item": "Item",
      "seller": "Seller",
      "amount": "Amount",
      "tracking": "Tracking",
      "dispatched": "Dispatched",
      "delivered": "Delivered",
      "rmStatus": "RM Status",
      "actions": "Actions"
    },
    "auctionItem": "Auction item",
    "track": "Track",
    "invoice": "Invoice",
    "contact": "Contact"
  },
  "disputesList": {
    "eyebrow": "Dispute Centre",
    "title": "Your disputes",
    "subtitle": "Track and respond to order disputes.",
    "loadError": "Could not load disputes: {message}",
    "loading": "Loading…",
    "empty": "No disputes yet.",
    "orderFallback": "Order",
    "openedOn": "#{id} · Opened {date}"
  },
  "disputeDetail": {
    "back": "← All disputes",
    "orderFallback": "Order dispute",
    "reference": "Dispute #{disputeId} · Order #{orderId}",
    "salePrice": "Sale price: {amount}",
    "shipping": "Shipping: {method}",
    "tracking": "Tracking: {number}",
    "reason": "Reason",
    "requestedResolution": "Requested resolution",
    "description": "Description",
    "adminResolution": "Admin resolution",
    "refund": "Refund: {amount}",
    "conversation": "Conversation",
    "internalNote": "Internal note",
    "noMessages": "No messages yet.",
    "messagePlaceholder": "Write a message…",
    "internalNoteCheckbox": "Internal admin note (not visible to buyer or seller)",
    "attachEvidence": "Attach evidence",
    "send": "Send",
    "evidence": "Evidence",
    "noEvidence": "No evidence uploaded yet.",
    "open": "Open",
    "evidenceMeta": "{role} · {name} · {size} KB",
    "adminActions": "Admin actions",
    "askBuyerEvidence": "Ask buyer for more evidence",
    "askSellerEvidence": "Ask seller for more evidence",
    "moveUnderReview": "Move to under review",
    "closeNoAction": "Close without financial action",
    "resolveSellerFavour": "Resolve in seller's favour (release payout)",
    "resolveBuyerFavour": "Resolve in buyer's favour (refund)",
    "closeTitle": "Close dispute without financial action",
    "resolveSellerTitle": "Resolve in seller's favour",
    "resolveBuyerTitle": "Resolve in buyer's favour (refund)",
    "resolveSellerDesc": "This will release the payout to the seller via Stripe.",
    "resolveBuyerDesc": "This will reverse any prior seller transfer and refund the buyer.",
    "closeDesc": "The order will proceed without any refund or transfer changes.",
    "refundAmountLabel": "Refund amount (GBP) — leave blank for full refund of {amount}",
    "resolutionNotesLabel": "Resolution notes (required, min 5 chars)",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "closedNotice": "Dispute closed.",
    "loading": "Loading…"
  },
  "timeline": {
    "ariaLabel": "Order status timeline",
    "placed": "Order placed",
    "paid": "Payment confirmed",
    "preparing": "Seller preparing",
    "preparingHint": "Awaiting dispatch from seller",
    "dispatched": "Dispatched",
    "inTransit": "In transit",
    "inTransitHint": "Tracking {number}",
    "delivered": "Delivered",
    "completed": "Completed",
    "issueReported": "Issue reported",
    "issueHint": "Support is reviewing this order",
    "inProgress": "In progress"
  },
  "disputeDialog": {
    "title": "Report a problem",
    "description": "Opening a dispute pauses seller payout until an admin reviews the case.",
    "orderLabel": "Order: {title}",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Choose a reason",
    "resolutionLabel": "What outcome are you asking for?",
    "resolutionPlaceholder": "Choose a resolution",
    "descriptionLabel": "Describe the issue",
    "descriptionPlaceholder": "Explain what happened (min 10 characters). You can attach photos on the dispute page after submitting.",
    "charCount": "{count}/4000 characters",
    "confirmCheckbox": "I understand this will open a formal dispute and pause seller payout.",
    "cancel": "Cancel",
    "submit": "Open dispute"
  }
}